<script>
import Loading from '@/components/Loading.vue'
import SliderRight from '@/components/SliderLeft.vue'
import http from '@/utils/http'
import { formatDate } from '@/utils/transform'

export default {
  name: 'CodigoIntegracaoEquipamento',
  components: { Loading, SliderRight },
  data() {
    return {
      codigosIntegracao: [],
      equipamentoCampoId: null,
      localId: null,
      equipamentoCampo: null,
      loading: true,
      openModalDelete: false,
      codigoId: null,
    }
  },
  beforeMount() {
    this.equipamentoCampoId = this.$route.params.equipamentoId
    this.localId = this.$route.params.localId
    this.loadData()
  },
  methods: {
    loadData() {
      this.loading = true
      http
        .get(`equipamento/${this.equipamentoCampoId}/integracao`)
        .then((response) => {
          this.codigosIntegracao = response.codigos
        })
        .finally(() => {
          this.loading = false
        })
    },
    setExcluir(id) {
      this.openModalDelete = true
      this.codigoId = id
    },
    onCancelDelete() {
      this.openModalDelete = false
      this.codigoId = null
    },
    onConfirmDelete() {
      this.openModalDelete = false
      http
        .post(`equipamento/integracao/remover-codigo`, {
          codigoId: this.codigoId,
          equipamentoId: this.equipamentoCampoId,
        })
        .then(() => {
          this.loadData()
        })
        .finally(() => {
          this.codigoId = null
          this.openModalDelete = false
        })
    },
    formatDate,
  },
}
</script>

<template>
  <div>
    <div>
      <div class="md-layout-item">
        <div class="md-layout">
          <div class="md-layout-item md-size-60">
            <span class="md-display-1"> Códigos de integração </span>
          </div>
          <div class="md-layout-item">
            <router-link
              v-if="$route.params.equipamentoId"
              :to="`/local/${$route.params.localId}/equipamento/${$route.params.equipamentoId}/editar`"
            >
              <md-button class="md-primary"> Voltar no equipamento </md-button>
            </router-link>
          </div>
        </div>
        <loading :loading="loading" />
        <md-table v-if="!loading">
          <md-table-row>
            <md-table-head>Descricao</md-table-head>
            <md-table-head>Usuário gerador</md-table-head>
            <md-table-head>Criação</md-table-head>
            <md-table-head>Ultimo uso</md-table-head>
          </md-table-row>

          <md-table-row v-for="codigo in codigosIntegracao" :key="codigo.id">
            <md-table-cell>{{
              codigo.descricao === '' ? '-' : codigo.descricao
            }}</md-table-cell>
            <md-table-cell>{{ codigo.username }}</md-table-cell>
            <md-table-cell>{{ formatDate(codigo.dataCriacao) }}</md-table-cell>
            <md-table-cell>
              {{
                codigo.ultimoUso !== null ? formatDate(codigo.ultimoUso) : '-'
              }}
            </md-table-cell>
            <md-table-cell>
              <md-button
                class="md-accent md-raised"
                @click="() => setExcluir(codigo.id)"
              >
                Excluir
              </md-button>
            </md-table-cell>
          </md-table-row>
        </md-table>
      </div>

      <md-dialog-confirm
        :md-active.sync="openModalDelete"
        md-title="Deseja deletar esse tipo?"
        md-content="Essa ação não poderá ser desfeita!"
        md-confirm-text="Sim"
        md-cancel-text="Cancelar"
        @md-cancel="onCancelDelete"
        @md-confirm="onConfirmDelete"
      />
    </div>
  </div>
</template>

<style scoped lang="scss"></style>
